module.exports = __webpack_public_path__ + "img/home-decor.75452a49.webp";